var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReclaim(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.77167 0.151724C4.78997 0.0679293 4.87434 0 4.96011 0H9.15322C9.23899 0 9.29369 0.0679293 9.27539 0.151724L8.3807 4.24828C8.3624 4.33207 8.27803 4.4 8.19226 4.4H3.99915C3.91338 4.4 3.85868 4.33207 3.87698 4.24828L4.77167 0.151724Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2072 0.151724C10.2255 0.0679293 10.3099 0 10.3956 0H17.3842C18.4134 0 19.0697 0.815151 18.8501 1.82069L16.398 13.0483C16.3797 13.1321 16.2953 13.2 16.2096 13.2H12.2361C12.1503 13.2 12.0659 13.2679 12.0476 13.3517L11.153 17.4483C11.1347 17.5321 11.1893 17.6 11.2751 17.6H15.2486C15.3344 17.6 15.3891 17.6679 15.3708 17.7517L14.4761 21.8483C14.4578 21.9321 14.3734 22 14.2876 22H10.0945C10.0088 22 9.95406 21.9321 9.97236 21.8483L10.8671 17.7517C10.8854 17.6679 10.8307 17.6 10.7449 17.6H6.55177C6.466 17.6 6.41131 17.5321 6.42961 17.4483L7.3243 13.3517C7.3426 13.2679 7.42697 13.2 7.51274 13.2H11.7059C11.7916 13.2 11.876 13.1321 11.8943 13.0483L13.5843 5.31035C13.6941 4.80758 13.3659 4.4 12.8513 4.4H9.43466C9.34889 4.4 9.2942 4.33207 9.3125 4.24828L10.2072 0.151724Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.80033 5.31035C3.71456 5.31035 3.63019 5.37827 3.61189 5.46207L0.0331248 21.8483C0.0148236 21.9321 0.0695187 22 0.155289 22H4.3484C4.43417 22 4.51854 21.9321 4.53684 21.8483L8.1156 5.46207C8.1339 5.37827 8.07921 5.31035 7.99344 5.31035H3.80033Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReclaim);
export default __webpack_public_path__ + "static/media/reclaim.9603b3c5ee07f99f360f120a120a43f8.svg";
export { ForwardRef as ReactComponent };